<div class="column-container">
  <div class="row">
    <div *ngFor="let column of field.columns" class="col-md-auto column-body"  ngxDroppable="designer" [style.width.%]="column.width">
      <div *ngFor="let subField of column.fields">
        <next-viewer-element [form]="form" [field]="subField" [initialState]="initialState" [needsValidation]="needsValidation" (valueChanged)="emitValueChanged($event)"></next-viewer-element>
      </div>
    </div>
  </div>
</div>
